import type { Translate } from '@/shared/api/errors'
import en from '@/app/i18n/en.json'
import uz from '@/app/i18n/uz.json'

type SeedFile = { seed?: Record<string, Record<string, string>> }

/**
 * Migratsiya o'zbekcha nom bilan yaratgan yozuvning nomi — panel tilida.
 *
 * Tarjima faqat nom hali asl holida turganda qo'llanadi: tenant
 * o'zgartirgan nom uning o'z matni. Asl nom — `uz.json` dagi aynan shu
 * kalitning qiymati (migratsiyadagi satr) yoki uning inglizchasi: devaf'da
 * tizim turlari qo'lda inglizchaga o'girilgan.
 */
export function seededName(
  group: string,
  code: string | null | undefined,
  name: string,
  t: Translate,
): string {
  if (!code) return name
  const seeded = [uz, en].map((lang) => (lang as SeedFile).seed?.[group]?.[code])
  if (!seeded.includes(name)) return name
  return t(`seed.${group}.${code}`, { defaultValue: name })
}
